import type { IntlShape } from 'react-intl';

import type { CreateUIAnalyticsEvent } from '@atlaskit/analytics-next/types';

import DefaultExtensionProvider from '@atlaskit/editor-common/extensions/default-extension-provider';
import type { ExtensionProvider } from '@atlaskit/editor-common/extensions/extension-provider';

import type { Snippet } from '../types/snippet.ts';

import { snippetExtensionManifest } from './snippetExtensionManifest.tsx';

export const snippetExtensionProvider = (
	intl: IntlShape,
	snippets: Snippet[],
	onOpenTemplatePanel?: () => void,
	userId?: string | null,
	createAnalyticsEvent?: CreateUIAnalyticsEvent | null,
): ExtensionProvider => {
	if (!onOpenTemplatePanel && (!snippets || snippets.length === 0)) {
		return new DefaultExtensionProvider([]);
	}

	const manifest = snippetExtensionManifest({
		snippets: snippets || [],
		intl,
		onOpenTemplatePanel,
		userId,
		createAnalyticsEvent,
	});

	return new DefaultExtensionProvider([manifest]);
};
